import "./App.css";
import { 
  Routes,
  Route,
  Navigate,useLocation
} from "react-router-dom";
import DockList from "./components/masters/dockmaster/dockmasterlist";
import Dock from "./components/dock/docklist";
import VehicleList from "./components/masters/vehicletype/vehiclelist";
import DockAdd from "./components/masters/dockmaster/dockadd";
import VehicleAdd from "./components/masters/vehicletype/vehicleadd";
import ViewDock from "./components/dock/dockview";
import AddDock from "./components/dock/dockadd";
import Docks from "./components/report/customizedreports";
import QuickReport from "./components/report/QuickReport";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

import "./components/Navbar/NavStyle.css";
import DashDock from "./components/Dashboard/Docks";
import Dashboard from "./components/Dashboard/Dashboard";
import Navbars from "./components/Navbar/Navbar";
import Default from "./components/Dashboard/Default";
import "./components/Dashboard/Dashboard.css";
import HelpQuestions from "./components/common/help";
import Futuristic from "./components/Dashboard/Futuristic";
import React, {createContext, useEffect, useState, useRef } from "react";
import { useGlobal } from "./GlobalContext";
import axios from "axios";
import { getCookie } from "./components/getcookie";
import PreLanding from "./pre-landing";
import UnAuthorized from "./components/common/unauthorized";
function App() {
 const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const location = useLocation();
    // List of paths where header should be hidden
    const hideHeaderPaths = ["/"];

    const shouldHideHeader = hideHeaderPaths.includes(location.pathname);
 const { rolePermissionList, setRolePermissionList, userType, setUserType } = useGlobal();

    useEffect(() => {

      getRolePermission();
    }, []);
  
    const getRolePermission = async () => {
       
        try {
          const response = await axios.get(adminApiUrl+"get_role_permission/9", {
            params: { },
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                "Accept": "application/json",      
                "Access-Control-Allow-Origin": "*", // Required for CORS support to work
                 "Authorization":getCookie("mawalog")
              }
          }).then((response) => {
            if(response.status===200){
                if (response.data.success === true) {
                  setUserType(response.data.user_type);
                  setRolePermissionList(response.data.role_permission??[]); 
                  localStorage.setItem("rolePermissionList", JSON.stringify(response.data.role_permission??[]));
                  localStorage.setItem("userType", response.data.user_type??'');  
                  console.log('lsr',localStorage.getItem("rolePermissionList"))
                  console.log('lsu',localStorage.getItem("userType"))
                               
                }else{
                  setRolePermissionList([]);
                }
            }
          }).catch((error) => {
            if (error.response) {
              console.error("Error Status:", error.response.status);
              console.error("Error Data:", error.response.data);
              if(error.response.status===401){ 
                document.cookie = 'redirectPath=' + window.location.href + '; path=/; domain=.mawalog.com';
                document.cookie = 'mawalog=; path=/; domain=.mawalog.com';
                window.location.href = accountsUrl;
                }
            } else {
              console.error("Request failed:", error.message);
            }
          });;
    
         // const data = await response.json();
        
        } catch (err) {
          console.error("Error fetching floors:", err);
        
        } finally {
          
        }
      };
  return (
    <>
      {!shouldHideHeader && <Navbars />}
      <Routes>
         <Route path="/" element={<PreLanding />} />
       {/*  <Route path="/" element={<Navigate to="/dashboard/default" />} /> */}

        <Route path="/dashdock" element={<DashDock />} />
        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="default" element={<Default />} />
          <Route path="futuristic" element={<Futuristic />} />
        </Route>

        <Route path="/dockmaster" element={(userType==="SA" || userType==="A")?<DockList/>:<UnAuthorized/>} />
        <Route path="/vehicletype" element={(userType==="SA" || userType==="A")?<VehicleList/>:<UnAuthorized/>} />
        <Route path="/dockadd" element={(userType==="SA" || userType==="A")?<DockAdd/>:<UnAuthorized/>} />
        <Route path="/vehicleadd"element={(userType==="SA" || userType==="A")?<VehicleAdd/>:<UnAuthorized/>}  />
        <Route path="/dock" element={<Dock />} />
        <Route path="/viewdock" element={<ViewDock />} />
        <Route path="/adddock" element={<AddDock />} />
        <Route path="/customized" element={<Docks />} />
        <Route path="/quick-report" element={<QuickReport />} />
        <Route path="/help" element={<HelpQuestions />}></Route>
        

      </Routes>
    </>
  );
}

export default App;
